import { Injectable } from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';

@Injectable()
export class IntermService {

  constructor(private http:Http) { }

  registrase(body){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/intermediario/registro`;

    return this.http.post(url, body, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  validateUser(user:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'user';

        return this.http.post(url, user,{headers: headers}).toPromise()
        .then(response => {
        return response.json() as any;
        }).catch(this.handleError)
    }
    recoverUser(user:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'user/recover';

        return this.http.post(url, user,{headers: headers}).toPromise()
        .then(response => {
        return response.json() as any;
        }).catch(this.handleError)
    }


    getCotizaciones(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'cotizacion/intermediario';

        return this.http.post(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }
      getCotizacion(id:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'cotizacion/intermediario/'+id;

        return this.http.get(url,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }
     saveCotizacion(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'cotizacion/intermediario';

        return this.http.put(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }
     sendCotizacion(id:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'cotizacion/interm/'+id;

        return this.http.get(url,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }
     getComisiones(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'comision/intermediario';

        return this.http.post(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }

     getClientes(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'cliente/intermediario';

        return this.http.post(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }
     getPasajeros(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'pasajero/intermediario';

        return this.http.post(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }

      getPerfil(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'perfil/'+request;

        return this.http.get(url,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }

        savePerfil(request:string): Promise<any>   {
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'perfil';

        return this.http.post(url,request,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as any;
          }).catch(this.handleError)
    }

    setPass(request:string): Promise<any>   {
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'perfil/password';

    return this.http.post(url,request,{headers: headers}).toPromise()
      .then(response => {
        return response.json() as any;
      }).catch(this.handleError)

    }
   /**
   * Handles error thrown during HTTP call
   * @param error:any
   * @returns {Promise<never>}
   */
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/general/interm.service.ts